angular.module('octopusApp.configuration')
    .controller('AuditFilterDialogController', function ($scope, $q, $uibModalInstance, $location, busy, octopusPermissionSet, visibleTenantFilter, octopusRepository, selectedValues, systemUserFactory, octopusTagSets) { 
        var vm = this;
        vm.isLoading = busy.create();
        vm.close = $uibModalInstance.close;
        vm.save = save;

        function refreshSelectedValues() {
          vm.selectedFilters = {
            users: selectedValues.selectedUsers || [],
            projects: selectedValues.selectedProjects || [],
            environments: selectedValues.selectedEnvironments || [],
            eventGroups: selectedValues.selectedEventGroups || [],
            eventCategories: selectedValues.selectedEventCategories || [],
            tenants: selectedValues.selectedTenants || [],
            tagSets: selectedValues.selectedTags || [],
            eventGroupCategories: [],
            documentTypes: selectedValues.selectedDocumentTypes || []
          };
        }

        var allTenants = [];
        var systemUser = systemUserFactory;


        function save() {
            $uibModalInstance.close({
                selectedUsers: vm.selectedFilters.users || [],
                selectedProjects: vm.selectedFilters.projects || [],
                selectedEnvironments: vm.selectedFilters.environments || [],
                selectedEventGroups: vm.selectedFilters.eventGroups || [],
                selectedEventCategories: vm.selectedFilters.eventCategories || [],
                selectedTenants: vm.selectedFilters.tenants || [],
                selectedTags: vm.selectedFilters.tagSets || [],
                selectedDocumentTypes: vm.selectedFilters.documentTypes || []
            });
        }

        function init() {
            var perm = 'AuditView';
            octopusPermissionSet.isAuthorized({ permission: perm }).then(function(yn) {
                if(yn) {
                    var promises = [];
                    promises.push(octopusRepository.Users.all().then(function(users) {
                        vm.usersByUsername = {};
                        vm.users = users;
                        vm.users.unshift(systemUser);
                        _.each(users, function(user) {
                            vm.usersByUsername[user.Username] = user;
                        });
                    }));
                    promises.push(octopusRepository.Projects.all().then(function(projects) {
                        vm.projects = projects;
                    }));
                    promises.push(octopusRepository.Environments.all().then(function(environments) {
                        vm.environments = environments;
                    }));
                    promises.push(octopusRepository.Events.categories().then(function (eventCategories) {
                        vm.eventCategories = eventCategories;
                    }));
                    promises.push(octopusRepository.Events.groups().then(function (eventGroups) {
                        vm.eventGroups = eventGroups;
                    }));
                    promises.push(octopusRepository.Events.documentTypes().then(function (documentTypes){
                        vm.documentTypes = documentTypes;
                    }));
                    if (octopusRepository.Tenants) {
                        promises.push(octopusTagSets.getAll().then(function (tagSets) {
                            vm.tagSets = tagSets.filter(function (ts) {
                                return ts.Tags.length > 0;
                            });
                            vm.selectedTags = _.clone(selectedValues.selectedTags);
                        }));
                        promises.push(octopusRepository.Tenants.all().then(function (tenants) {
                            allTenants = tenants;
                            vm.availableTenants = allTenants.filter(function (tenant) {
                                return !visibleTenantFilter(tenant);
                            });
                        }));
                    }

                    vm.isLoading.promises(promises).then(function() {
                      refreshSelectedValues();
                    });
                } else {
                    vm.isLoading.showError("You do not have permission to perform this action. Please contact your Octopus administrator. Missing permission: "+ perm);
                }
            });
        }

        init();
    });



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/audit/controllers/audit_filter_dialog_controller.js
// module id = 1709758848303826
// module chunks = 1